export default "/images/vendor/flag-icon-css/flags/4x3/tl.svg?b51e57c22b21dd25774430ffd8b06d7f";